import {jsx as _jsx} from "react/jsx-runtime";import {Suspense} from 'react'
import {Redirect} from 'react-router'
import meetingSeriesRedirectorQuery, {

} from '../__generated__/MeetingSeriesRedirectorQuery.graphql'
import useQueryLoaderNow from '../hooks/useQueryLoaderNow'
import useRouter from '../hooks/useRouter'
import MeetingSeriesRedirector from './MeetingSeriesRedirector'

const MeetingRoot = () => {
  const {match} = useRouter()
  const {params} = match
  const {meetingId} = params
  const queryRef = useQueryLoaderNow(meetingSeriesRedirectorQuery, {
    meetingId
  })
  if (!meetingId) return _jsx(Redirect, { to: "/meetings",} )
  return (
    _jsx(Suspense, { fallback: '', children: 
      queryRef && _jsx(MeetingSeriesRedirector, { meetingId: meetingId, queryRef: queryRef,} )
    })
  )
}

export default MeetingRoot
